#import "@/apollo/fragments/Job.gql"

mutation AddDownloadComputedDeliverablesJob(
    $campaignId: ID!
    $exportFormat: ExportFormat!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $deviceScaleFactor: Int
    $platformOpts: InputDownloadJobPlatformOptions
) {
    addDownloadComputedDeliverablesJob(
        campaignId: $campaignId
        exportFormat: $exportFormat
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        deviceScaleFactor: $deviceScaleFactor
        platformOpts: $platformOpts
    ) {
        ...Job
    }
}
